'use client'

import { AppWrapper } from '~/components/app-wrapper'
import { SiteFooter } from '~/components/site-footer'
import { HomePage } from '~/domains/home/components/pages/home-page'

export const Page = () => {
	return (
		<AppWrapper>
			<HomePage />
			<SiteFooter />
		</AppWrapper>
	)
}
